const WIDTHS = [480, 768, 1280];

export const imgSrc = (name, w = 1280) => `/img/${name}-${w}.webp`;
export const imgSrcSet = (name) => WIDTHS.map((w) => `${imgSrc(name, w)} ${w}w`).join(", ");

// Responsive, lazy-by-default studio image served from /public/img (webp, 3 sizes).
export const Img = ({ name, alt, sizes = "100vw", priority = false, className = "", ...rest }) => (
  <img
    src={imgSrc(name)}
    srcSet={imgSrcSet(name)}
    sizes={sizes}
    alt={alt}
    loading={priority ? "eager" : "lazy"}
    decoding="async"
    fetchPriority={priority ? "high" : "auto"}
    className={className}
    {...rest}
  />
);
